module.exports = __webpack_public_path__ + "img/ST Logo with bckgrnd.ddd2fb7d.jpg";